<template>
  <div id="gwi-voucherRegister" class="app bg-gray">
    <div class="scroll">
      <!-- 注册电子健康卡 -->
      <section
        class="flex-row choose-type-section"
        :class="validVoucherCount ? '' : 'disabled'"
        @click="registerCard()"
      >
        <div class="flex-1 choose-type-register-logo"></div>
        <div class="flex-3 flex-col flex-justify-center">
          <p class="f-large f-strong">申请电子健康卡</p>
          <p class="f-small f-normal" style="margin-top: 5px">
            通过本人身份证信息完成办卡
          </p>
        </div>
      </section>
      <!-- 绑定就诊卡 -->
      <!--<section class="flex-row choose-type-section" :class="validVoucherCount ? '' : 'disabled'" @click="bindCard()">-->
      <!--&lt;!&ndash; 图标 &ndash;&gt;-->
      <!--<div class="flex-1 choose-type-bind-logo">-->
      <!--</div>-->
      <!--&lt;!&ndash; 文案 &ndash;&gt;-->
      <!--<div class="flex-3 flex-col flex-justify-center">-->
      <!--<p class="f-large f-strong">绑定就诊凭证</p>-->
      <!--<p class="f-small f-normal" style="margin-top: 5px">已有居民健康卡绑定</p>-->
      <!--</div>-->
      <!--</section>-->
      <!-- 提醒区域 -->
      <div v-if="!validVoucherCount" class="voucher-choose-type-bottom-tips">
        <p class="f-strongest">
          您当前已绑定的就诊凭证已满，无法绑定更多就诊凭证
        </p>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import utils from 'utils'
import voucherService from 'voucher.service'
export default {
  components: {

  },
  data () {
    return {
      // 是否来自微信公众号菜单
      isFromWechatMenu: this.$router.currentRoute.query.code,
      // 当前卡数量是否正常
      validVoucherCount: true
    }
  },
  created () {
    // 如果不是从公众号的菜单直接过来的，则不需要再判断卡数量
    if (!this.isFromWechatMenu) {
      return
    }
    voucherService.getVoucherList().then((res) => {
      if (res.resultCode !== this.constant.RESULT_SUCCESS) {
        this.$utils.alert(res.resultMsg)
        return
      }
      this.validVoucherCount = res.data.length < 3
    })
  },
  mounted () {

  },
  methods: {
    registerCard () {
      if (!this.validVoucherCount) {
        return
      }
      this.$store.commit('updateParam', {
        namespace: 'voucherChooseType',
        isFromWechatMenu: this.isFromWechatMenu
      })
      this.$router.push('voucherRegister');
    },
    bindCard () {
      if (!this.validVoucherCount) {
        return
      }
      this.$store.commit('updateParam', {
        namespace: 'voucherChooseType',
        isFromWechatMenu: this.isFromWechatMenu
      })
      this.$router.push('voucheradd');
    },

  },
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";
.choose-type-section {
  height: 2rem;
  margin: 0.5rem;
  border-radius: 5px;
  border: 1px solid #ccc;
  &.disabled {
    background: $common-disable-color;
    color: rgb(34, 34, 34);
    box-shadow: none;
  }
}
.choose-type-register-logo {
  background-image: url(../../../static/img/icon-create-card.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50%;
}
.choose-type-bind-logo {
  background-image: url(../../../static/img/icon-bind-card.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 50%;
}
.voucher-choose-type-bottom-tips {
  margin: 15px 15px;
}
</style>



// WEBPACK FOOTER //
// VoucherChooseType.vue?5e282c26